import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';

const Printscreen = styled.div`
  width: fit-content;
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-tertiary);
  margin-top: var(--space-12);
  overflow: hidden;
  :first-child {
    margin-top: var(--space-10);
  }
`;

const ActionDiv = styled.div`
  display: flex;
  .figma-button {
    order: 2;
    border-radius: var(--border-radius-6);
  }
  .three-dot-icon {
    display: flex;
    gap: var(--space-12);
    order: 3;
  }
  .active {
    border-radius: var(--border-radius-6);
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    /* this is given to manage spacing of 30px */
    &.figma-right-div {
      padding-left: var(--space-6);
      margin-left: var(--space-24);
    }
  `)}
`;

export { Printscreen, ActionDiv };
